import React from 'react';
import { RendererContext } from '../../context';
export var useIsMacro = function useIsMacro() {
  var _React$useContext = React.useContext(RendererContext),
    extensionType = _React$useContext.extensionType;
  return extensionType === 'xen:macro';
};